import React, { useState, useEffect } from "react";
const ES4Update = ({ ...props }) => {
    const [load, setload] = useState(true)
    const [ncoError, setNcoError] = useState(false)
    const [formData, setFormData] = useState({
        Es4detailsId: Number(props.es4detailsId),
        NcoCode20158DigitLevel2: "0",
        TradeInWhichTrained3: 0,
        Registration4: 0,
        Placement5: 0,
        LiveRegister6: 0,
        Registration7: 0,
        Placement8: 0,
        LiveRegister9: 0,
        Apikey1: '',
    });


    const getdata = async () => {
        const sendData = {
            Es4detailsId: Number(props.es4detailsId),
        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Main/GetES4Details', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.text().then(text => text ? JSON.parse(text) : null);
            })
            .then(
                data => {
                    if (data && data.length > 0) {
                        const maindata = data[0]
                        //console.log(maindata)
                        setFormData({
                            NcoCode20158DigitLevel2: maindata.ncoCode20158DigitLevel2,
                            TradeInWhichTrained3: maindata.tradeInWhichTrained3,
                            Registration4: maindata.registration4,
                            Placement5: maindata.placement5,
                            LiveRegister6: maindata.liveRegister6,
                            Registration7: maindata.registration7,
                            Placement8: maindata.placement8,
                            LiveRegister9: maindata.liveRegister9,
                            Apikey1: maindata.apikey1,
                            Es4detailsId: Number(props.es4detailsId),
                        });
                    }
                    setload(false)
                })
            .catch(error => {
                console.error('Error fetching data:', error);
                setload(false);
            })


    };
    const onInputChange = async (e) => {
        e.target.value < 0 ? e.target.value = null : Number(e.target.value)
        setFormData({ ...formData, [e.target.name]: Number(e.target.value) });
        const sendData = {
            ...formData, [e.target.name]: Number(e.target.value)
        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Main/UpdateDetailsES4', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.text().then(text => text ? JSON.parse(text) : null);
            })
            .then(
                maindata => {
                    if (maindata) {
                        setFormData({
                            NcoCode20158DigitLevel2: maindata.ncoCode20158DigitLevel2,
                            TradeInWhichTrained3: maindata.tradeInWhichTrained3,
                            Registration4: maindata.registration4,
                            Placement5: maindata.placement5,
                            LiveRegister6: maindata.liveRegister6,
                            Registration7: maindata.registration7,
                            Placement8: maindata.placement8,
                            LiveRegister9: maindata.liveRegister9,
                            Apikey1: maindata.apikey1,
                            Es4detailsId: Number(props.es4detailsId),
                        });
                    }
                    setload(false)
                })
            .catch(error => {
                console.error('Error updating data:', error);
                setload(false);
            })
        props.setGTotal(props.GTotal + 1)
    };


    const onInputChange2 = async (e) => {
        e.target.value < 0 ? e.target.value = null : Number(e.target.value)
        setFormData({ ...formData, [e.target.name]: e.target.value });
        const sendData = {
            ...formData, [e.target.name]: e.target.value
        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Main/UpdateDetailsES4', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.text().then(text => text ? JSON.parse(text) : null);
            })
            .then(
                maindata => {
                    if (maindata) {
                        setFormData({
                            NcoCode20158DigitLevel2: maindata.ncoCode20158DigitLevel2,
                            TradeInWhichTrained3: maindata.tradeInWhichTrained3,
                            Registration4: maindata.registration4,
                            Placement5: maindata.placement5,
                            LiveRegister6: maindata.liveRegister6,
                            Registration7: maindata.registration7,
                            Placement8: maindata.placement8,
                            LiveRegister9: maindata.liveRegister9,
                            Apikey1: maindata.apikey1,
                            Es4detailsId: Number(props.es4detailsId),
                        });
                    }
                    setload(false)
                })
            .catch(error => {
                console.error('Error updating data:', error);
                setload(false);
            })
       
    };


    const onInputChange3 = async (e) => {
        e.target.value < 0 ? e.target.value = null : String(e.target.value)
        setFormData({ ...formData, [e.target.name]: String(e.target.value) });
        const sendData = {
            ...formData, [e.target.name]: String(e.target.value)
        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Main/UpdateDetailsES4', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.text().then(text => text ? JSON.parse(text) : null);
            })
            .then(
                maindata => {
                    if (maindata) {
                        setFormData({
                            NcoCode20158DigitLevel2: maindata.ncoCode20158DigitLevel2,
                            TradeInWhichTrained3: maindata.tradeInWhichTrained3,
                            Registration4: maindata.registration4,
                            Placement5: maindata.placement5,
                            LiveRegister6: maindata.liveRegister6,
                            Registration7: maindata.registration7,
                            Placement8: maindata.placement8,
                            LiveRegister9: maindata.liveRegister9,
                            Apikey1: maindata.apikey1,
                            Es4detailsId: Number(props.es4detailsId),
                        });
                    }
                    setload(false)
                })
            .catch(error => {
                console.error('Error updating data:', error);
                setload(false);
            })
        props.setGTotal(props.GTotal + 1)
    };



    useEffect(() => {
        getdata()

    }, [props.Change])

    const inputHandler = (e) => {
        const { value, maxLength } = e.target;
        if (String(value).length >= maxLength) {
            e.preventDefault();
            return;
        }
    };

    const handleNcoChange = async (e, showAlert = true) => {
        let value = e.target.value.replace(/[^0-9Xx]/g, '');
        
        if (value.length > 8) {
            value = value.slice(0, 8);
            e.target.value = value;
            if (showAlert) {
                const Swal = (await import('sweetalert2')).default;
                Swal.fire({
                    icon: 'warning',
                    title: 'Invalid Input',
                    text: 'Please enter a valid 8 character NCO code',
                    confirmButtonText: 'OK'
                });
            }
            
            return;
        }
        
        if (value.length === 8) {
            setNcoError(false);
        }
        
        setFormData({ ...formData, NcoCode20158DigitLevel2: value });
        const sendData = {
            ...formData, NcoCode20158DigitLevel2: value
        }

        await fetch(process.env.REACT_APP_API_LINK + 'api/Main/UpdateDetailsES4', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)
        })
            .then(response => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.text().then(text => text ? JSON.parse(text) : null);
            })
            .then(
                maindata => {
                    if (maindata) {
                        setFormData({
                            NcoCode20158DigitLevel2: maindata.ncoCode20158DigitLevel2,
                            TradeInWhichTrained3: maindata.tradeInWhichTrained3,
                            Registration4: maindata.registration4,
                            Placement5: maindata.placement5,
                            LiveRegister6: maindata.liveRegister6,
                            Registration7: maindata.registration7,
                            Placement8: maindata.placement8,
                            LiveRegister9: maindata.liveRegister9,
                            Apikey1: maindata.apikey1,
                            Es4detailsId: Number(props.es4detailsId),
                        });
                    }
                    setload(false)
                })
            .catch(error => {
                console.error('Error updating data:', error);
                setload(false);
            })
        props.setGTotal(props.GTotal + 1)
    };
   

    return (
        load ? null :
            <tr scope="row"  >
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.value}
                </td>

                {/* <td style={{ textAlign: 'center', border: '1px solid black', padding: 10}} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="NcoCode20158DigitLevel2"
                       className="form-control" maxLength="8" onKeyPress={inputHandler}
                        name="NcoCode20158DigitLevel2"
                        style={{ textAlign: 'center' }}onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange3(e)} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '.') && evt.preventDefault()}
                        defaultValue={formData.NcoCode20158DigitLevel2}
                    /> : formData.NcoCode20158DigitLevel2}

                </td>*/}
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="text"
                        inputMode="text"
                        pattern="[0-9Xx]*"
                        id="NcoCode20158DigitLevel2"
                        className="form-control"
                        name="NcoCode20158DigitLevel2"
                        style={{ textAlign: 'center', borderColor: ncoError ? 'red' : '', borderWidth: ncoError ? '2px' : '' }}
                        onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null}
                        onBlur={async (e) => {
                            const value = e.target.value.replace(/[^0-9Xx]/g, '');
                            if (value.length > 0 && value.length < 8) {
                                setNcoError(true);
                                const Swal = (await import('sweetalert2')).default;
                                Swal.fire({
                                    icon: 'warning',
                                    title: 'Invalid Input',
                                    text: 'Please enter a valid 8 character NCO code',
                                    confirmButtonText: 'OK'
                                });
                            } else if (e.target.value == '') {
                                e.target.value = 0;
                                setNcoError(false);
                            } else if (value.length === 8) {
                                setNcoError(false);
                            }
                        }}
                        onChange={handleNcoChange}
                        onPaste={(e) => {
                            e.preventDefault();
                            const pasted = e.clipboardData.getData('Text');
                            e.target.value = pasted;
                            handleNcoChange(e, true);
                        }}
                        onKeyDown={(evt) => {
                            if (!/[0-9Xx]/.test(evt.key) && evt.key !== 'Backspace' && evt.key !== 'Delete' && evt.key !== 'ArrowLeft' && evt.key !== 'ArrowRight' && evt.key !== 'Tab') {
                                evt.preventDefault();
                            }
                        }}
                        defaultValue={formData.NcoCode20158DigitLevel2}
                    /> : formData.NcoCode20158DigitLevel2}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="text"
                        id="Apikey1"
                        className="form-control" maxLength="30" onKeyPress={inputHandler}
                        name="Apikey1"
                        style={{ textAlign: 'center' }}
                        onKeyDown={(evt) => (evt.keyCode > 64 && evt.keyCode < 96) || (evt.keyCode > 0 && evt.keyCode < 33) || evt.preventDefault()}
                        onChange={(e) => onInputChange2(e)} defaultValue={formData.Apikey1}
                    /> : formData.Apikey1}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Registration4"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="Registration4"
                        style={{ textAlign: 'center' }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Registration4}
                    /> : formData.Registration4}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Placement5"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="Placement5"
                        style={{ textAlign: 'center' }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Placement5}
                    /> : formData.Placement5}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="LiveRegister6"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="LiveRegister6"
                        style={{ textAlign: 'center' }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.LiveRegister6}
                    /> : formData.LiveRegister6}
                </td>
                {/* <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {formData.Registration4 - formData.Placement5}

                </td>*/}

                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Registration7"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="Registration7"
                        style={{ textAlign: 'center' }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Registration7}
                    /> : formData.Registration7}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="Placement8"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="Placement8"
                        style={{ textAlign: 'center' }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.Placement8}
                    /> : formData.Placement8}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {props.edit ? <input
                        type="number"
                        min="0"
                        id="LiveRegister9"
                        className="form-control" maxLength="7" onKeyPress={inputHandler}
                        name="LiveRegister9"
                        style={{ textAlign: 'center' }} onFocus={(e) => e.target.value == 0 ? e.target.value = '' : null} onBlur={(e) => e.target.value == '' ? e.target.value = 0 : e.target.value}
                        onChange={(e) => onInputChange(e)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.keyCode === 38 || evt.keyCode === 40 || evt.key === '-') && evt.preventDefault()}
                        defaultValue={formData.LiveRegister9}
                    /> : formData.LiveRegister9}
                </td>
                {/*<td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                    {formData.Registration7 - formData.Placement8}

                </td>*/}
            </tr>
    );
};

export default ES4Update;
